import { render, staticRenderFns } from "./JoinEventForm.vue?vue&type=template&id=218ae96e&scoped=true&"
import script from "./JoinEventForm.vue?vue&type=script&lang=js&"
export * from "./JoinEventForm.vue?vue&type=script&lang=js&"
import style0 from "./JoinEventForm.vue?vue&type=style&index=0&id=218ae96e&lang=scss&scoped=true&"
import style1 from "./JoinEventForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218ae96e",
  null
  
)

export default component.exports